import React, { useState } from "react";
import Badge from "../ui-components/Badge";
import Button from "../ui-components/Button";
import Input from "../ui-components/Input";
import Label from "../ui-components/Label";

const ArrayOfStringInput = ({ label, value, setValue, disabled }) => {
  const [input, setInput] = useState("");
  return (
    <div className="mb-1">
      {label ? <Label>{label}</Label> : null}
      <div className="flex flex-wrap w-full mb-2 mt-2">
        {value.map((v, index) => (
          <div
            onClick={() => {
              setValue(value.filter((o) => v !== o));
            }}
            key={v + index}
            className="mb-2 mr-2 cursor-pointer"
          >
            <Badge text={v} />
          </div>
        ))}
      </div>

      <div className="flex w-full justify-between items-center">
        <Input
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
          }}
          label={"Add value"}
          type="text"
          disabled={disabled}
        />
        <Button
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            setValue([...value, input]);
            setInput("");
          }}
        >
          ADD
        </Button>
      </div>
      <div className="mb-4" />
    </div>
  );
};

export default ArrayOfStringInput;
